import { createSlice, createAsyncThunk, createEntityAdapter, } from "@reduxjs/toolkit";
import { envAwarePost, envAwareFormSubmit } from "../../../util/util";

export const sortPackages = createAsyncThunk(
    'sortPackages',
    async ({srcIdx,tgtIdx},{getState})=>{
        const state = getState()
        const ids = state.packages.ids
        return envAwarePost(
            'api/packages/',
            {action:'sortPackages',ids}
        )
    }
)

export const fetchPackages = createAsyncThunk(
    "fetchPackages",
    async () => envAwarePost('api/packages/',{action:'fetchPackages'})
)

export const deletePackage = createAsyncThunk(
    "deletePackage",
    async id => envAwarePost('api/packages/', {
        action:'deletePackage',
        id
    })
)

export const editPackage = createAsyncThunk(
    "editPackage",
    async update => envAwarePost('api/packages/', {
        action:'editPackage',
        id:update.package_id,
        update
    })
)

export const createPackage = createAsyncThunk(
    "createPackage",
    async payload => envAwarePost(
        'api/packages/', 
        {
            action:'createPackage',
            ...payload
        }
    )
)

export const toggleActivate = createAsyncThunk(
    "toggleActivate",
    async payload => envAwarePost(
        'api/packages/', 
        {
            action:'editPackage',
            ...payload
        }
    )
)

const packageAdapter = createEntityAdapter({
    selectId: ent => ent.package_id,
})

const packageSlice = createSlice({
    name: "packages",
    
    initialState: packageAdapter.getInitialState({
        status:'init',
        programAssign:{
            show:false,
            programs:[],
            clientId:null
        },
        editor:{
            show:false,
            id:null
        },
        cart:{
            currencyId:null,
            //map from id to qty to being purchased
            idQtyMap:{},
            show:false
        }
    }),

    reducers: {
        setEditor: (state,action)=>{
            state.editor.show = action.payload.show
            state.editor.id = action.payload.id
        },
        setCartShow: (state,action)=>{
            state.cart.show = action.payload
        },
        updateCartItem: (state,action)=>{
            const {id,qty,currencyId} = action.payload
            if(!Boolean(state.currencyId)){
                state.cart.currencyId = currencyId
            }
            //prevent multiple currencies in cart (should never happen from a typical user)
            //but happens often in dev
            if(state.cart.currencyId === currencyId){
                if (qty===0) {
                    delete state.cart.idQtyMap[id]
                } else {
                    state.cart.idQtyMap[id] = qty
                }
            }
        },
        clearCart: (state)=>{
            state.cart = {
                currencyId:null,
                show:false,
                idQtyMap:{}
            }
        },
        updateProgramAssign: (state,action)=>{
            state.programAssign = {
                ...state.programAssign,
                ...action.payload
            }
        }
    },

    extraReducers: {
        [fetchPackages.pending]: (state, action) => {
            state.status = 'pending'
        },

        [fetchPackages.fulfilled]: (state, action) => {
            const { success, data } = action.payload;
            state.status = 'idle'
            if (success == 1) {
                const {packages} = data
                packageAdapter.setAll(state, packages)
            }
        },

        [deletePackage.pending]: (state, action) => {
            packageAdapter.removeOne(state, action.meta.arg)
        },

        [toggleActivate.pending]: (state, action) => {
            const {update:{is_active},id} = action.meta.arg
            const updateObject = {id, changes: {is_active}}
            packageAdapter.updateOne(state, updateObject)
        },

        [editPackage.fulfilled]: (state, action) => {
            let id = action.meta.arg.package_id;
            if (action.payload.success === "1") {
                const pkg = action.payload.data.package
                packageAdapter.upsertOne(state, pkg)
            }
        },

        [createPackage.fulfilled]: (state, action) => {
            if ( action.payload.success === "1" ) {
                packageAdapter.addOne(state, action.payload.data.package)
            }
        },
        [sortPackages.pending]: (state,action)=>{
            const {srcIdx,tgtIdx} = action.meta.arg
            const ids = state.ids
            //get a temp array with the src item removed
            const tmpNoSrc = [
                ...ids.slice(0, srcIdx),
                ...ids.slice(srcIdx + 1)
            ]
            
            const idsUpdate = [
                ...tmpNoSrc.slice(0, tgtIdx),
                ids[srcIdx],
                ...tmpNoSrc.slice(tgtIdx)
            ]
            state.ids = idsUpdate
            idsUpdate.forEach((id,idx)=>{
                state.entities[id].sort_order = idx
            })
        }
    },
})

//DO NOT USE addToCart directly. 
//Instead use the wrapper returned from the hook usePackageCart
export const {
    setEditor,
    updateCartItem,
    setCartShow,
    clearCart,
    updateProgramAssign
} = packageSlice.actions

export const {
    selectAll: selectAllPackages,
    selectById: selectPackageById,
    selectIds: selectPackageIds
} = packageAdapter.getSelectors(state => state.packages)

export const selectPackagesByIds = (state,ids)=>ids.map((id)=>selectPackageById(state,id))


export default packageSlice.reducer;